import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { Header } from "./components/Header"
import { Footer } from './components/footer'
import { FixedAppointmentButtons } from './components/FixedAppointmentButtons'
import Home from './pages/Home'
import AboutTest from './pages/AboutTest'
import History from './pages/about/History'
import AboutAwards from './pages/about/Awards'
import Facilities from './pages/about/Facilities'
import Infrastructure from './pages/about/Infrastructure'
import PranaamGlance from './pages/about/PranaamGlance'
import InTheNews from './pages/about/InTheNews'
import Contact from './pages/Contact'
import MaternityMatters from './pages/MaternityMatters'
import WomenCare from './pages/WomenCare'
import Locations from './pages/Locations'
import MadinagudaBranch from './pages/locations/MadinagudaBranch'
import NallagandlaBranch from './pages/locations/NallagandlaBranch'
import IsnapurBranch from './pages/locations/IsnapurBranch'
import ZaheerabadBranch from './pages/locations/ZaheerabadBranch'
import Services from './pages/Services'
import Cardiology from './pages/services/Cardiology'
import Neurology from './pages/services/Neurology'
import Orthopedics from './pages/services/Orthopedics'
import Paediatric from './pages/services/Paediatric'
import PaediatricSurgery from './pages/services/PaediatricSurgery'
import Gynaecology from './pages/services/Gynaecology'
import Dentistry from './pages/services/Dentistry'
import Gastroenterology from './pages/services/Gastroenterology'
import GeneralSurgery from './pages/services/GeneralSurgery'
import GeneralMedicine from './pages/services/GeneralMedicine'
import Neonatology from './pages/services/Neonatology'
import PrenatalYoga from './pages/services/PrenatalYoga'
import CriticalCare from './pages/services/CriticalCare'
import Pathology from './pages/services/Pathology'
import Neurosurgery from './pages/services/Neurosurgery'
import Oncology from './pages/services/Oncology'
import UrologyNephrology from './pages/services/UrologyNephrology'
import LaparoscopicSurgery from './pages/services/LaparoscopicSurgery'
import Physiotherapy from './pages/services/Physiotherapy'
import Dietetics from './pages/services/Dietetics'
import Dermatology from './pages/services/Dermatology'
import ENT from './pages/services/ENT'
import Endocrinology from './pages/services/Endocrinology'
import Pulmonology from './pages/services/Pulmonology'
import PlasticCosmeticSurgery from './pages/services/PlasticCosmeticSurgery'
import Psychology from './pages/services/Psychology'
import Radiology from './pages/services/Radiology'
import DiagnosticsPage from './pages/DiagnosticsPage'
import Videos from './pages/media/Videos'
import Blogs from './pages/media/Blogs'
import DoctorsPage from './pages/DoctorsPage'
import BookAppointment from './pages/BookAppointment'
import ScrollToTop from './pages/ScrollToTop'
import Doctordetail from './pages/Doctordetail'
import BlogDetailPage from './pages/blogs/BlogDetail'
import Testimonials from './pages/testimonials'
import Servicesdetail from './pages/services/Servicesdetail'
import Notfound from './pages/404'
import WomenCareDetailPage from "./pages/womens-care/womencaredetail"
import MaternityCareDetail from "./pages/maternity/maternitycaredetail"
import BookNow from './pages/book-now/page'
import DoctorsListPage from './pages/book-now/doctors-list'
import DoctorBookingPage from './pages/book-now/doctor-booking'
import Overview from './pages/discover/Overview'
import VisionMission from './pages/discover/VisionMission'
import Leadership from './pages/discover/Leadership'
import Achievements from './pages/discover/Achievements'
import Careers from './pages/discover/Careers'
import PortalDashboard from './pages/PortalDashboard'
import ProfilePage from './pages/Profile'
import MyReportsPage from './pages/MyReports'
import PrescriptionsPage from './pages/Prescriptions'
import BillsReceiptsPage from './pages/BillsReceipts'
import MyBookingsPage from './pages/MyBookings'
import MyPackagesPage from './pages/MyPackages'
import ScannerPage from './pages/Scanner'
import MyOrdersPage from './pages/MyOrders'
import OffersPage from './pages/Offers'
import AddressPage from './pages/Address'
import FamilyMembersPage from './pages/FamilyMembers'
import AcademicsResearch from './pages/academics/AcademicsResearch'
import PranaamKnowledge from './pages/academics/Knowledge'
import ResearchInnovations from './pages/academics/Research'
import ExcellenceReport from './pages/academics/ExcellenceReport'
import Publications from './pages/academics/Publications'
import LocationPage from './pages/LocationPage'
import CitizensCharter from './pages/patient-care/CitizensCharter'
import PrivacyPolicy from './pages/patient-care/PrivacyPolicy'
import RefundCancellation from './pages/patient-care/RefundCancellation'
import TermsConditions from './pages/patient-care/TermsConditions'
import CareerDetail from './pages/discover/CareerDetail'
import Packages from './pages/packages/Packages'
import PackageDetail from './pages/packages/PackageDetail'
 
import ProtectedRoute from './components/auth/ProtectedRoute'
import "./index.css"
 
function Layout() {
  const location = useLocation()
  const profilePaths = ['/portal-dashboard', '/profile', '/my-reports', '/prescriptions', '/bills-receipts', '/my-bookings', '/my-packages', '/family-members']
  const hideHeader = profilePaths.includes(location.pathname)
  const hideAppointmentButton = ['/book-appointment', '/book-now', '/hospital-visit', '/video-consultation', ...profilePaths].includes(location.pathname) || location.pathname.startsWith('/book-now/')
  const hideFooter = profilePaths.includes(location.pathname)
 
  return (
    <>
      {!hideHeader && <Header />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutTest />} />
        <Route path="/History" element={<History />} />
        <Route path="/Awards" element={<AboutAwards />} />
        <Route path="/Facilities" element={<Facilities />} />
        <Route path="/Infrastructure" element={<Infrastructure />} />
        <Route path="/PranaamGlance" element={<PranaamGlance />} />
        <Route path="/InTheNews" element={<InTheNews />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/maternity-matters" element={<MaternityMatters />} />
        <Route path="/women-care" element={<WomenCare />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/:slug" element={<LocationPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<Servicesdetail />} />
        <Route path="/diagnostics" element={<DiagnosticsPage />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/packages/:id" element={<PackageDetail />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/doctors" element={<DoctorsPage />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
        <Route path="/doctors/:slug" element={<Doctordetail />} />
        <Route path="/blogs/:slug" element={<BlogDetailPage />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="*" element={<Notfound />} />
        <Route path="/women-care/:slug" element={<WomenCareDetailPage />} />
        <Route path="/womencare/:slug" element={<MaternityCareDetail />} />
        <Route path="/book-now" element={<DoctorsListPage />} />
        {/* <Route path="/book-now/:doctorSlug" element={<DoctorBookingPage />} /> */}
        <Route path="/hospital-visit" element={<DoctorBookingPage />} />
        <Route path="/video-consultation" element={<BookNow />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/vision-mission" element={<VisionMission />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:slug" element={<CareerDetail />} />
        <Route path="/portal-dashboard" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/my-reports" element={<ProtectedRoute><MyReportsPage /></ProtectedRoute>} />
        <Route path="/my-orders" element={<ProtectedRoute><MyOrdersPage /></ProtectedRoute>} />
        <Route path="/prescriptions" element={<ProtectedRoute><PrescriptionsPage /></ProtectedRoute>} />
        <Route path="/bills-receipts" element={<ProtectedRoute><BillsReceiptsPage /></ProtectedRoute>} />
        <Route path="/my-bookings" element={<ProtectedRoute><MyBookingsPage /></ProtectedRoute>} />
        <Route path="/my-packages" element={<ProtectedRoute><MyPackagesPage /></ProtectedRoute>} />
        <Route path="/scanner" element={<ScannerPage />} />
        <Route path="/offers" element={<OffersPage />} />
        <Route path="/address" element={<AddressPage />} />
        <Route path="/family-members" element={<ProtectedRoute><FamilyMembersPage /></ProtectedRoute>} />
        <Route path="/academics" element={<AcademicsResearch />} />
        <Route path="/knowledge" element={<PranaamKnowledge />} />
        <Route path="/research" element={<ResearchInnovations />} />
        <Route path="/excellence-report" element={<ExcellenceReport />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/citizens-charter" element={<CitizensCharter />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-cancellation" element={<RefundCancellation />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
        {!hideAppointmentButton && <FixedAppointmentButtons />}
        {/* <Footer /> */}
        {!hideFooter && <Footer />}
      </>
  )
}
 
function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  )
}
 
export default App
